import { z } from 'zod'

import { AvailableCurrencies } from 'common/settings/constants/AvailableCurrencies'

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
}

export enum OrderStatus {
  PAID = 'paid',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}

const UserSchema = z.object({
  user_id: z.string(),
  name: z.string(),
  avatar: z.string().url(),
  status: z.nativeEnum(UserStatus),
  gender: z.nativeEnum(Gender),
})

const AdditionalDataSchema = z
  .object({
    name: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    shipping_country: z.string().nullable(),
    shipping_line1: z.string().nullable(),
    shipping_line2: z.string().nullable(),
    shipping_city: z.string().nullable(),
    shipping_state: z.string().nullable(),
    shipping_zip: z.string().nullable(),
  })
  .nullable()

const OrderSchema = z.object({
  id: z.number(),
  order_id: z.string(),
  subscriber_id: z.number(),
  user: UserSchema.nullable(),
  ts_created: z.number(),
  status: z.nativeEnum(OrderStatus),
  amount: z.string(),
  currency: z.nativeEnum(AvailableCurrencies),
  description: z.string(),
  ts_charged: z.number().nullable(),
  additional_data: AdditionalDataSchema,
  charge_source: z.string().nullable(),
})

const OrdersInfoByStatusSchema = z.object({
  status: z.nativeEnum(OrderStatus),
  num: z.number().int().min(0),
})

const SuccessedOrdersInfoByCurrencySchema = z.object({
  currency: z.nativeEnum(AvailableCurrencies),
  num: z.number().int().min(0),
  amount: z.string(),
})

export const GetOrdersListResponseSchema = z.object({
  orders_list: z.array(OrderSchema),
  limiter: z.number().or(z.string()).nullable(),
  orders_info_by_status: z.array(OrdersInfoByStatusSchema),
  successed_orders_info_by_currency: z.array(SuccessedOrdersInfoByCurrencySchema),
})

export const GetOrdersListRequestSchema = z.object({
  subscriber_id: z.number(),
})

export type Order = z.infer<typeof OrderSchema>
export type GetOrdersListResponse = z.infer<typeof GetOrdersListResponseSchema>
export type GetOrdersListRequest = z.infer<typeof GetOrdersListRequestSchema>
export type AdditionalData = z.infer<typeof AdditionalDataSchema>
